import { create } from 'zustand';

interface IPriceState {
  currentItemId: string | number | null;
  setCurrentItemId(id: string | number | null): void;
}

const usePriceStore = create<IPriceState>()((set, get) => ({
  currentItemId: null,
  setCurrentItemId(id) {
    set(state => ({ currentItemId: id }));
  }
}));

export default usePriceStore;
